import React, { HTMLAttributes } from 'react';
import c from 'classnames';

import { CoreLink } from '../../../../../components';
import useClasses from '../../../../../hooks/useClasses';
import { ImmutableMenuItem } from '../../..';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLUListElement>> {
  entity: ImmutableMenuItem;
}

const MenuMainItemDefault: React.FC<Props> = ({ className, entity }) => {
  const { buildClass, joinClasses } = useClasses('MenuMainItem');

  const href = entity.getIn(['link', 'url'], '');
  const title = entity.getIn(['link', 'title'], '');

  const iconClasses = c(
    'icon',
    'icon-size-sm',
    'icon-variant-11',
    className,
  );

  return (
    <li key={href}>
      <CoreLink to={href} className={buildClass()}>
        {className && (
          <div className={joinClasses(buildClass('icon'), iconClasses)} />
        )}
        {title}
      </CoreLink>
    </li>
  );
};

export default MenuMainItemDefault;
